// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","dark-red":"#a30000","white":"#ffffff","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","grey":"#707070","black":"#000000","normal":".3s","inputField":"_3b_8Gfw9exCJsxN9AvYRJU","select":"_3LCBx3SvHlv3uowmOZLeK-","selectedMeter":"_2sSttqeVnMFoPuVh1DEKUb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/inputs/Dropdown/Dropdown.css
// module id = 861
// module chunks = 0